import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { POST_ART_REQUEST, POST_ART_REQUEST_SUCCESS, POST_ART_FAIL, GET_ART_BY_USER_ID_REQUEST } from "./actionTypes"
import { postArtRequest, postArtSuccess, getArtFail, postArtFail, getArtByUserIdFail, getArtByUserIdSuccess } from "./actions"
import { getArtByUserIdApi, postArtApi } from "helpers/backend_helper";
import toastr from "toastr";




function* onPostArt({ payload: { formData, callback } }) {
  try {

    const response = yield call(postArtApi, formData);
    if (response.status === "failure") {
      window.scrollTo(0, 0);
      callback && callback(response);
      return yield put(postArtFail(response.message));
    }

    callback && callback(response);

    yield put(postArtSuccess());
  } catch (error) {
    yield put(postArtFail("Internal Error!"));
  }
}
function* onGetArtByUserId({ payload: { user_id, callback } }) {
  try {

    const response = yield call(getArtByUserIdApi, user_id);
    if (response.status === "failure") {
      window.scrollTo(0, 0);

      return yield put(getArtByUserIdFail(response.message));
    }
    callback && callback(response);
    yield put(getArtByUserIdSuccess(response));

   
  } catch (error) {
    yield put(getArtByUserIdFail("Internal Error!"));
  }
}

function* ArtSaga() {
  yield takeEvery(POST_ART_REQUEST, onPostArt);
  yield takeEvery(GET_ART_BY_USER_ID_REQUEST, onGetArtByUserId);

}

export default ArtSaga;